const {GENDER_MALE} = require('./../../genderList')
const {CREATURE_TYPE_NORKER} = require('./../../creatureTypeIdList')

module.exports = {
  id: CREATURE_TYPE_NORKER,
  nameEn: 'Norker',
  genderId: GENDER_MALE,
  hideFromStatBlock: true,
  name: {
    singular: {
      nominative: 'норкер',
      genitive: 'норкера',
      dative: 'норкеру',
      accusative: 'норкера',
      instrumental: 'норкером',
      prepositional: 'норкере',
    },
    plural: {
      nominative: 'норкеры',
      genitive: 'норкеров',
      dative: 'норкерам',
      accusative: 'норкеров',
      instrumental: 'норкерами',
      prepositional: 'норкерах',
    },
  },
}
